import React, { useEffect, useState } from 'react';
import { Modal, View, Text, TextInput, TouchableOpacity, StyleSheet } from 'react-native';
import { colores } from '../../../../styles/variablesCss';
import { BACKEND_URL } from '../../../../Config/Const';
import Revalidate from './Revalidate';

const RevalidateEmailModal = ({ visible, onClose, mail }) => {
  const [newEmail, setNewEmail] = useState(mail);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showValidationCodeModal, setShowValidationCodeModal] = useState(false);
  const [validationCode, setValidationCode] = useState('');

  useEffect(() => {
    if (visible) {
      setNewEmail(mail);
      setError('');
      setIsLoading(false);
      setShowValidationCodeModal(false);
      setValidationCode('');
    }
  }, [visible, mail]);

  const handleClose = (result = false) => {
    setShowValidationCodeModal(false);
    setValidationCode('');
    setError('');
    setIsLoading(false);
    if (typeof onClose === 'function') onClose(result);
  };

  const handleRevalidate = async () => {
    if (!newEmail) {
      setError('Por favor ingrese un email válido');
      return;
    }
    const body = JSON.stringify({
      "request": {
        mail: mail,
        mailNuevo: newEmail,
      }
    });
    setIsLoading(true);
    try {
      const response = await fetch(`${BACKEND_URL}/rest/usuarios/revalidar-mail`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body
      });

      const data = await response.json();

      if (response.ok) {
        setShowValidationCodeModal(true);
        setError('');
      } else {
        setError(data.dsResultado?.resultado?.[0]?.mensaje || 'Error al enviar el código');
      }
    } catch (error) {
      console.error('Error al enviar código:', error);
      setError('Error de conexión');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Modal
        visible={visible}
        transparent={true}
        animationType="slide"
        onRequestClose={() => handleClose(false)}
      >
        <View style={styles.modalOverlay}>
          <View style={styles.modalContent}>
            <View style={styles.container}>
              <TouchableOpacity 
                style={styles.closeButton} 
                onPress={() => handleClose(false)}
                hitSlop={{ top: 10, right: 10, bottom: 10, left: 10 }}
                accessibilityRole="button"
                accessibilityLabel="Cerrar"
              >
                <Text style={styles.closeButtonText}>×</Text>
              </TouchableOpacity>

              <Text style={styles.title}>Confirma tu Email</Text>

              <TextInput
                style={styles.inputPill}
                placeholder="Ingresá tu email"
                value={newEmail}
                onChangeText={setNewEmail}
                keyboardType="email-address"
                autoCapitalize="none" 
                editable={!isLoading}
                placeholderTextColor="#A0A0A0"
              />

              {error ? <Text style={styles.errorText}>{error}</Text> : null}

              <TouchableOpacity
                style={styles.button}
                onPress={handleRevalidate}
                disabled={isLoading}
              >
                <Text style={styles.buttonText}>
                  {isLoading ? 'Enviando...' : 'Validar'}
                </Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>

      <Revalidate
        visible={showValidationCodeModal}
        onClose={(success) => {
          setShowValidationCodeModal(false);
          setValidationCode('');
          setError('');
          if (success) {
            handleClose(true);
          }
        }}
        email={newEmail}
        code={validationCode}
        setCode={setValidationCode}
        error={error}
        setError={setError}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
      />
    </>
  );
};

const styles = StyleSheet.create({
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContent: {
    backgroundColor: 'white',
    borderRadius: 10,
    padding: 20,
    width: '92%',
    maxWidth: 480,
  },
  container: {
    position: 'relative',
  },
  closeButton: {
    position: 'absolute',
    right: -19,
    top: -33,
    padding: 10,
    zIndex: 1,
  },
  closeButtonText: {
    fontSize: 30,
    color: colores.rojo || '#E31837',
    fontWeight: 'bold',
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 20,
    textAlign: 'center',
    color: colores.rojo || '#E31837',
  },
  // Input estilo pill para coherencia
  inputPill: {
    height: 42,
    width: '100%',
    backgroundColor: '#FFFFFF',
    borderRadius: 21,
    paddingHorizontal: 16,
    borderWidth: 1,
    borderColor: '#E5E5E5',
    fontSize: 15,
    marginBottom: 15,
  },
  button: {
    backgroundColor: '#E31837',
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 6,
    alignItems: 'center',
    alignSelf: 'center',
    minWidth: 180,
  },
  buttonText: {
    color: 'white',
    fontSize: 18,
    fontWeight: '700',
  },
  errorText: {
    color: 'red',
    marginBottom: 10,
  },
});

export default RevalidateEmailModal;
